import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
    return (
        <div style={{ fontFamily: 'Arial, sans-serif', padding: '20px', backgroundColor: '#1e1e1e', color: '#fff', height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <h1 style={{ fontSize: '3em', color: '#ff6f61' }}>404 - Page Not Found</h1>
            <p style={{ fontSize: '1.5em', color: '#ccc', textAlign: 'center', maxWidth: '600px' }}>
                Oops! The page you're looking for doesn't exist. It might have been moved or deleted.
            </p>
            <Link to="/" style={{ fontSize: '1.2em', color: '#007bff', textDecoration: 'none', marginTop: '20px' }}>
                Go back to the homepage
            </Link>
        </div>
    );
}

export default NotFound;
